

class ImmersiveScroller {
	constructor( node ) {

		this.node = node;
		const items = this.node.querySelectorAll('.immersive-scroller-item');
		this.items = [...items];

		if (!this.items.length) {
			return;
		}
		this.opts = {
			classes: {
				nodeActive: 'immersive-scroller--active',
				itemActive: 'immersive-scroller-item--active',
				fixMedia: 'immersive-scroller--fix-media',
				navigation: '.immersive-scroller__navigation-dots',
				navigationItem: '.immersive-scroller__navigation-dots',
				container: '.immersive-scroller-items__inner',
				dotActive: 'immersive-scroller__navigation-dot--active',
				previousElement: '.immersive-scroller__before',
				nextElement: '.immersive-scroller__after',
			},
		};


		this.opened = false;
		this.buffer = 1;
		this.previousY = 0;
		this.nextElement = this.node.querySelector(this.opts.classes.nextElement);
		this.previousElement = this.node.querySelector(this.opts.classes.previousElement);
		this.container = this.node.querySelector(this.opts.classes.container);
		this.navigation = {
			container: this.node.querySelector(this.opts.classes.navigation),
			item: this.node.querySelector(this.opts.classes.navigationItem)
		};

		this.observers = {
			item: new IntersectionObserver(
				(entries) => this.itemInView(entries),
				{
					threshold: [0.81, 0.85, 0.9, 0.95, 0.96, 0.97, 0.98, 0.99, 1]
				}
			),
			neighbor: new IntersectionObserver(
				(entries) => this.deactivate(entries),
				{
					threshold: 1,
				}
			),
			node: new IntersectionObserver(
				(entries) => this.nodeInView(entries),
				{
					threshold: 0.05,
				}
			),
		}

		// one navigation circle per item
		this.navigation.container.innerHTML = this.items.map((item) => this.navigation.item.innerHTML).join('');

		// all other items use the itemInView observer
		this.items.forEach((item) => {
			this.observers.item.observe(item);
		});

		// to maybe capture rapid scrolling, target the next and previous siblings
		this.observers.neighbor.observe(this.nextElement);
		this.observers.neighbor.observe(this.previousElement);
		this.observers.node.observe(this.node);

		// and a final hail mary using the footer and header, useful for those that use hotkeys to jump through the page.
		// this.observers.neighbor.observe(document.getElementById('footer'));
		// this.observers.neighbor.observe(document.getElementById('masthead'));

	}

	init() {
		this.opened = true;
		this.node.classList.add(this.opts.classes.nodeActive);
		this.node.classList.add(this.opts.classes.fixMedia);
	}

	nodeInView(entries) {
		entries.forEach((entry) => {
			if ( entry.isIntersecting ) {

				this.interval = setInterval(() => {
					const distanceFromTopOfViewport = this.node.getBoundingClientRect().y;
					if (distanceFromTopOfViewport === 0) {
						if (!this.opened) {
							this.init();
						}
						clearInterval(this.interval);
					}
				}, 33);

			} else {
				this.node.classList.remove(this.opts.classes.nodeActive);
				this.deactivate();
			}
		});
	}


	itemInView(entries) {

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const activated = entry.target.classList.contains(this.opts.classes.itemActive);

				if ( entry.intersectionRatio > 0.7) {

					if(! this.opened) {
						this.init();
					}
					this.deactivateItems();
					this.activateItem(entry.target);
				}
			}
		});
	}

	deactivate(entries = false) {
		if (!this.opened) {
			return;
		}

		if (!entries) {
			this.deactivateItems();
			this.node.classList.remove(this.opts.classes.fixMedia);
			this.opened = false;
			return;
		}

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				this.deactivateItems();
				this.node.classList.remove(this.opts.classes.fixMedia);
				this.opened = false;
			}
		});
	}

	activateItem(target) {
		target.classList.add(this.opts.classes.itemActive);
		this.adjustDots(target);
	}

	deactivateItems() {
		this.items.forEach((item) => {
			this.deactivateItem(item);
		});
	}

	deactivateItem(target) {
		target.classList.remove(this.opts.classes.itemActive);
	}

	getIndexOfTarget(target) {
		return [...this.container.children].indexOf(target) ?? 0;
	}

	adjustDots( target ) {
		const index = this.getIndexOfTarget(target);
		const dots = [...this.navigation.container.children];

		dots.forEach((dot) => {
			dot.classList.remove(this.opts.classes.dotActive);
		});

		// highlight index + 1 dots
		dots.slice(0, index + 1).map((dot) => {
			dot.classList.add(this.opts.classes.dotActive);
		});
	}

}

const instances = document.querySelectorAll('.immersive-scroller');
ImmersiveScroller.instances = [ ...instances].map((instance) => new ImmersiveScroller(instance));

export default ImmersiveScroller;
